import * as React from 'react'

import Dashboard from '@material-ui/icons/Dashboard'
import Person    from '@material-ui/icons/Person'

import { AccountType }         from '../api'
import {
  Companies,
  EditPersonalInformation,
  Users,
}                              from '../components/environments'
import App                     from '../components/environments/App'
import { Routing, SubRouting } from '../types'
import ProgramRouting          from './ProgramRouting'

const dashboardRouting: SubRouting = [
  {
    name:      'programs',
    path:      '/programs',
    component: ProgramRouting,
  },
  {
    name:      'companies',
    path:      '/companies',
    component: Companies,
  },
  {
    name:      'coaches',
    path:      '/coaches',
    component: () => <Users accountType={AccountType.Coach} />,
  },
  {
    name:      'coachees',
    path:      '/coachees',
    component: () => <Users accountType={AccountType.Coachee} />,
  },
]

const profileRouting = [
  {
    name:      'personal',
    path:      '/personal',
    component: EditPersonalInformation,
  }
]

const routing: Routing = [
  {
    name:       'dashboard',
    path:       '/dashboard',
    icon:       <Dashboard />,
    subrouting: dashboardRouting,
  },
  {
    name:       'profile',
    path:       '/profile',
    icon:       <Person />,
    subrouting: profileRouting,
  },
]

export default () => <App routing={routing} />



// WEBPACK FOOTER //
// ./src/routing/BLCCoaching.tsx